import React, { FunctionComponent } from 'react';
import Layout from '../../containers/layout';
import {useQuery} from "@apollo/react-hooks";
import {GET_PUBLISHED_EVENTS_QUERY} from "../../graphql/queries";
import EventItem from "./components/EventItem";

const NewsAndEvents: FunctionComponent = () => {
  const { data } = useQuery(GET_PUBLISHED_EVENTS_QUERY);

  return (
    <Layout showImageHeader imageHeaderPath="/images/pattern-resources.png">
      <div className="bg-light">
        <div className="w-10/12 lg:w-10/12 mx-auto">
          <h1 className="text-3xl font-bold pt-16">
            News And Events
          </h1>
          <div className="flex flex-col pb-20">
            {data && data.publishedEvents.map((event: any, index: number) => (
              <EventItem
                key={event.slug}
                alignment={index % 2 === 0 ? 'left': 'right'}
                title={event.title}
                createdAt={event.createdAt}
                slug={event.slug}
                coverImage={event.coverImage && event.coverImage.path}
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default NewsAndEvents;
